import { useParams } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import SectionLabel from '../components/SectionLabel'
import BlogCard from '../components/BlogCard'
import WACTASection from '../components/WACTASection'
import { posts } from '../data/blog'
import { GUIDE_NAME } from '../constants'

export default function BlogPost() {
  const { slug } = useParams()
  const post = posts.find(p => p.slug === slug)
  
  if (!post) return <div style={{ padding: '100px', textAlign: 'center' }}>Post not found</div>

  const related = posts.filter(p => p.slug !== slug).sort(() => 0.5 - Math.random()).slice(0, 2)

  return (
    <main style={{ background: 'var(--white)' }}>
      {/* Hero */}
      <section style={{ background: 'var(--stone)', padding: '100px 5% 60px', textAlign: 'center' }}>
        <SectionLabel>{post.category}</SectionLabel>
        <h1 className="serif" style={{ fontSize: 'clamp(28px, 5vw, 42px)', fontWeight: 600, maxWidth: '800px', margin: '0 auto 24px', lineHeight: 1.25 }}>
          {post.title}
        </h1>
        <div style={{ fontSize: '12px', color: 'var(--ink-light)', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 500 }}>
          By {GUIDE_NAME} · {post.date} · {post.readTime}
        </div>
      </section>

      {/* Content */}
      <section className="section" style={{ maxWidth: '820px', margin: '0 auto', paddingTop: '60px' }}>
        <div className="prose">
          <ReactMarkdown>{post.content}</ReactMarkdown>
        </div>

        {/* Author Card */}
        <div style={{ marginTop: '80px', background: 'var(--stone)', padding: '32px', borderRadius: 'var(--radius-lg)', display: 'flex', gap: '24px', alignItems: 'center', border: '1px solid var(--stone-mid)' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: 'var(--green)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600, flexShrink: 0, fontSize: '24px', fontFamily: 'var(--serif)' }}>
            {GUIDE_NAME.charAt(0)}
          </div>
          <div>
            <div style={{ fontSize: '15px', fontWeight: 600, marginBottom: '4px' }}>Expert Insight by {GUIDE_NAME}</div>
            <p style={{ fontSize: '13px', color: 'var(--ink-mid)', lineHeight: 1.5, fontWeight: 300 }}>
              Independent trekking guide based in Kathmandu. Manaslu & Annapurna specialist. Direct WhatsApp bookings.
            </p>
          </div>
        </div>
      </section>

      {/* Related Reading */}
      <section className="section" style={{ borderTop: '1px solid var(--stone-mid)', maxWidth: '1200px', margin: '0 auto' }}>
        <h2 className="serif" style={{ fontSize: '26px', marginBottom: '32px' }}>Related reading.</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '32px' }}>
          {related.map(p => (
            <BlogCard key={p.slug} post={p} />
          ))}
        </div>
      </section>

      <WACTASection />

      <style>{`
        .prose h2 { font-family: var(--serif); font-size: 28px; font-weight: 600; margin: 48px 0 24px; color: var(--ink); }
        .prose h3 { font-family: var(--serif); font-size: 20px; font-weight: 600; margin: 32px 0 16px; color: var(--ink); }
        .prose p { margin-bottom: 24px; line-height: 1.8; color: var(--ink-mid); font-weight: 300; font-size: 16px; }
        .prose a { color: var(--color-accent-cool); text-decoration: underline; font-weight: 500; }
        .prose a:hover { color: var(--color-accent-signature); }
        .prose ul, .prose ol { margin-bottom: 24px; padding-left: 20px; color: var(--ink-mid); }
        .prose li { margin-bottom: 12px; font-size: 16px; font-weight: 300; }
        .prose blockquote { border-left: 4px solid var(--green); padding: 12px 24px; font-style: italic; margin: 40px 0; color: var(--green-dark); background: var(--green-light); font-family: var(--serif); font-size: 19px; }
        .prose table { width: 100%; border-collapse: collapse; margin-bottom: 32px; border: 1px solid var(--stone-mid); }
        .prose th, .prose td { padding: 14px 20px; border: 1px solid var(--stone-mid); font-size: 14px; text-align: left; }
        .prose th { background: var(--stone); font-weight: 600; color: var(--ink); }
        .prose strong { color: var(--ink); font-weight: 600; }
        .prose code { background: var(--stone); padding: 2px 6px; border-radius: 4px; font-size: 0.9em; }
      `}</style>
    </main>
  )
}
